import { Box, Typography, styled } from "@mui/material";
import { colors } from "../../../theme/colors";

export const ContentContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  width: "100%",
});

export const ModalTitle = styled(Typography)({
  fontSize: "26px",
  fontWeight: 600,
  color: colors.text.primary,
  textAlign: "center",
  marginBottom: "32px",
});

export const FieldsContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: "8px",
});

export const RowFieldsContainer = styled(Box)({
  display: "flex",
  gap: "12px",
  marginTop: "8px",
});

export const ButtonsContainer = styled(Box)({
  display: "flex",
  gap: "24px",
  justifyContent: "center",
  marginTop: "32px",
});
